// extracted by mini-css-extract-plugin
export var numpadContainer = "_nz-1";
export var phoneButton = "_nz-0";